import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, OnInit } from '@angular/core';
import { ContactGroup } from '@app/core/interfaces/c5/contact-group';
import { PhoneBookContact } from '@app/core/interfaces/c5/phone-book-contact';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { PortalError } from '@app/utils/error/portal-error';
import { PhoneBookType } from '@business/phone-book/models/PhoneBookType';
import { TranslateService } from '@ngx-translate/core';
import { FormGroupTyped } from 'src/types/typed-forms';
import { ContactsMode } from '../contacts/contacts.mode';
import { UpdateContactFormModel } from './update-contact-form-model';
import { UpdateContactInput } from './update-contact-input';

@Component({
  selector: 'portal-update-contact',
  templateUrl: './update-contact.component.html',
  styles: [],
  standalone: false,
})
export class UpdateContactComponent
  extends DialogComponent<UpdateContactInput, void>
  implements OnInit, UpdateContactInput
{
  contact?: PhoneBookContact;
  contactGroups: ContactGroup[];
  mode: ContactsMode;
  update: (contact: PhoneBookContact | Partial<PhoneBookContact>) => Promise<any>;

  error?: PortalError;
  entry: Partial<PhoneBookContact> | PhoneBookContact;
  form: FormGroupTyped<UpdateContactFormModel> = UpdateContactFormModel.formGroup();
  resetValue: UpdateContactFormModel;
  saving: boolean = false;

  sliderOptions: Options = {
    floor: 0,
    ceil: 100,
    translate: (value, label) => {
      let translation: string = value.toString();

      if (label === LabelType.Low) {
        if (value === 0) {
          translation = this.translateService.instant('acd.vip.priority.none');
        } else {
          translation = `VIP <small>${value}</small>`;
        }
      }

      return translation;
    },
  };

  constructor(protected translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    if (this.contact !== undefined) {
      this.entry = this.contact;
    } else {
      this.entry = this.newEntry();
    }

    this.updateEntryAndForm();
  }

  reset() {
    this.form.reset(this.resetValue);
    this.form.markAsPristine();
    this.form.markAsUntouched();
  }

  submit() {
    if (this.saving === false) {
      this.resetValue = this.form.getRawValue();
      const model = UpdateContactFormModel.merge(this.entry, this.resetValue);

      this.saving = true;

      this.update(model)
        .then(() => {
          // this.form.markAsPristine()
          this.close();
        })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  private newEntry(): Partial<PhoneBookContact> {
    return {
      id: 0,
      bookType:
        this.mode === ContactsMode.CALL_CENTER_ADMIN || this.mode === ContactsMode.CALL_CENTER_SUPERVISOR
          ? PhoneBookType.CALL_CENTER
          : null,
      vipPriority: 0,
      groups: [],
    };
  }

  private updateEntryAndForm() {
    this.resetValue = UpdateContactFormModel.from(this.entry);
    this.form.patchValue(this.resetValue);
  }
}
